<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option mgb_5">
				<!-- <em class="lt_text">Sales Date</em> -->
				<span class="mgr_5">
					<select v-model="date_type" class="tbl_select" style="width:100px;">
						<option value="S">Sales Date</option>
						<option value="I">Invoice Date</option>
					</select>
				</span>
				<span class="mgr_5"> <CustomDatePicker v-model="date_from"/> ~ <CustomDatePicker v-model="date_to"/></span>

				<span class="mgr_5">
					<select v-model="partner_type" class="tbl_select" style="width:100px;">
						<option value="S">Ship To</option>
						<option value="B">Bill To</option>
					</select>
				</span>
				<span class="int_type_no_border mgr_5"> <PartnerSelect ph="Customer" :showName="false" v-model="searched_partner" @set-partner="setPartner" /> </span>
				<span class="int_type mgr_15" style="width:300px;">
					<input type="text" v-model.trim="partners_string" autocomplete="off" @focus="$event.target.select()" />
				</span>

				<CountrySelect v-model.trim="country" :bool="false" />

				<state-select v-model.trim="state" :country="country" />

				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" :displayDescription="true" v-model="sales_group_code"/></span>

				<!-- <span class="int_type sm_int"> <input type="text" v-model.trim="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" /> </span> -->
			</div>
			<div class="left_option mgb_5">
				<span class="mgr_10">
					<item-class-group v-model.trim="group_code" :headers="headers" />
				</span>

				<em class="lt_text">Item {{ headers.class }}</em>

				<span class="int_type" style="width:350px;">
					<AC ref="ac" :initialDisplay="keyword" :source="selectClasses" @selected="selectClass" results-display="code_name" placeholder="Item / Class Name or Code"> </AC>
				</span>

				<span class="int_type_no_border mgr_5">
					<ItemClassKeywordSearch @setClassList="addSearchingItemClasses" :customPlaceholder="`${headers.class} Code Starting with Keyword`" />
				</span>

				<span class="int_type_no_border mgr_15">
					<ItemClassSelectMulti v-model.trim="item_classes_string" :selectOnClick="false" :width="300" @keydown="search" />
				</span>

				<em class="lt_text">Item Color</em>
				<span class="int_type">
					<input type="text" v-model.trim="colors_string" placeholder="ex) 1, 2, 1B" autocomplete="off" @keyup.enter="search()" @focus="$event.target.select()" />
				</span>
				<!-- <span>(Only Applied In Case Of Searching by {{ headers.class }}.)</span> -->
			</div>
			<div class="left_option" style="padding-top:2px;">
				<span class="int_type_no_border">
					<ItemSelectMulti v-model.trim="selected_items_str" :active_only="false" :separator="separator" :resultsDisplay="obj => obj.item_code + ' | ' + obj.name" />
				</span>
				<span class="mgl_15">
					<label class="mgr_10"><input type="radio" value="A" v-model="option" /> All</label>
					<label class="mgr_10"><input type="radio" value="I" v-model="option" /> Invoice Issued</label>
					<label class="mgr_10"><input type="radio" value="U" v-model="option" /> Not issued</label>
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt mgr_15" @click="reset()">Reset</a>

				<label><input type="checkbox" v-model="is_summary" /> Summary</label>
				<label v-if="user.company_id == 'jc'" class="mgl_10"><input type="checkbox" v-model="by_category" /> By Category</label>
			</div>
		</div>
		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 95%">
				<table class="list_tbl sticky_list_tbl" v-columns-resizable id="excelTable">
					<template v-if="!is_summary_display">
						<thead>
							<tr>
								<th width="5%">
									<a href="javascript:;" @click="sort('so_dn')">SO No{{ sortMark('so_dn') }}</a>
								</th>
								<th width="5%">
									<a href="javascript:;" @click="sort('so_date')">SO Date{{ sortMark('so_date') }}</a>
								</th>
								<th width="5%">Status</th>
								<th width="5%">
									<a href="javascript:;" @click="sort('invoice_dn')">Inv. No{{ sortMark('invoice_dn') }}</a>
								</th>
								<th width="5%">
									<a href="javascript:;" @click="sort('invoice_date')">Inv. Date{{ sortMark('invoice_date') }}</a>
								</th>
								<th width="2%">
									<a href="javascript:;" @click="sort('type')">Type{{ sortMark('type') }}</a>
								</th>
								<th width="3%">Ship To</th>
								<th width="10%">Name</th>
								<th width="2%">Terr</th>
								<th v-if="company_id == 'beautyplus'" width="2%">State</th>
								<th width="5%">
									<a href="javascript:;" @click="sort('sales_group_name')">Sales Group{{ sortMark('sales_group_name') }}</a>
								</th>
								<th v-if="company_id == 'beautyplus'" width="5%">Salesman</th>
								<th width="5%">Group</th>
								<th width="5%">{{ headers.class }} Code</th>
								<th v-if="user.company_id != 'jc'" width="5%">Color</th>
								<th>
									<a href="javascript:;" @click="sort('item')">Item{{ sortMark('item') }}</a>
								</th>
								<th width="3%">On Hand</th>
								<th width="3%">Ord Qty.</th>
								<th width="3%">Inv Qty.</th>
								<th width="2%">Box</th>
								<th v-if="user.fob_price_view" width="3%">FOB Price</th>
								<th width="3%">Lock Price</th>
								<th width="3%">Price</th>
								<th v-if="user.company_id == 'jc'" width="3%">Discount</th>
								<th width="3%">Available Qty</th>
								<th width="3%">Available Amount</th>
								<th width="3%">Amount</th>
								<th width="3%">Invoice Amount</th>
								<th v-if="user.fob_price_view" width="3%">Margin(%)</th>
							</tr>
						</thead>
						<tbody>
							<template v-for="item in display_items">
								<tr v-if="item.is_subtotal" v-bind:key="'st-' + item.subtotal_key" style="background-color:#f0f0f0;font-weight:bold;">
									<td class="al_left" colspan="14">{{ item.class_group_name }} ({{ item.line_count }})</td>
									<td class="al_right">{{ item.quantity | commaSeparated }}</td>
									<td class="al_right">{{ item.shipped_quantity | commaSeparated }}</td>
									<td></td>
									<td v-if="user.fob_price_view"></td>
									<td></td>
									<td></td>
									<td class="al_right">{{ item.discount_amount | toCurrency }}</td>
									<td></td>
									<td></td>
									<td class="al_right">{{ item.amount | toCurrency }}</td>
									<td class="al_right">{{ item.invoice_amount | toCurrency }}</td>
									<td v-if="user.fob_price_view"></td>
								</tr>
								<tr v-else v-bind:key="item.invoice_item_no">
									<td class="al_left">
										<a href="javascript:;" @click="selectSO(item)">{{ item.so_dn }}</a>
									</td>
									<td class="al_left">{{ item.so_date }}</td>
									<td class="al_center truncate">{{ item.status_code | saleStatusName }}</td>
									<td class="al_left">
										<a href="javascript:;" @click="selectInvoice(item)">{{ item.invoice_dn }}</a>
									</td>
									<td class="al_left">{{ item.invoice_date }}</td>
									<td class="al_center">{{ item.invoice_type }}</td>
									<td class="al_left">
										<a href="javascript:;" @click="gotoPartner(item.ship_to_code)">{{ item.ship_to_code }}</a>
									</td>
									<td class="al_left truncate" :title="item.ship_to_name">
										<a href="javascript:;" @click="gotoPartner(item.ship_to_code)">{{ item.ship_to_name }}</a>
									</td>
									<td class="al_left">{{ item.territory_code }}</td>
									<td v-if="company_id == 'beautyplus'">{{ item.address_state }}</td>
									<td class="al_left">{{ item.sales_group_name }}</td>
									<td v-if="company_id == 'beautyplus'" class="al_left">{{ item.salesman_name }}</td>
									<td class="al_left">{{ item.class_group_name }}</td>
									<td class="al_left truncate" :title="item.class_code">{{ item.class_code }}</td>
									<td v-if="user.company_id != 'jc'" class="al_center truncate" :title="item.color_code">
										<a href="javascript:;" @click="selectColor(item)">{{ item.color_code }}</a>
									</td>
									<td class="al_left truncate" :title="item.item_name">
										{{ company_id !== 'newjigu' && item.item_name && item.item_name.lastIndexOf('-') >= 0 ? item.item_name.substring(0, item.item_name.lastIndexOf('-')) : item.item_name }}
									</td>
									<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
									<td class="al_right">{{ item.quantity | commaSeparated }}</td>
									<td class="al_right">{{ item.shipped_quantity | commaSeparated }}</td>
									<td class="al_right">{{ item.box_count | commaSeparated }}</td>
									<td class="al_right" v-if="user.fob_price_view">{{ item.fob_price | toCurrency }}</td>
									<td class="al_right">{{ item.lock_price | toCurrency }}</td>
									<td class="al_right">
										<span v-if="user.company_id == 'newjigu' && item.status_code == 'H'">
											{{ item.r_price | toCurrency }}
										</span>
										<span v-else>{{ item.unit_price | toCurrency }} </span>
									</td>
									<td v-if="user.company_id == 'jc'" class="al_right">{{ jcDiscount(item) | toCurrency }}</td>
									<td class="al_right">
										<a href="javascript:;" @click="selectPreemptedList(item.invoice_no, item.item_id)">
											{{ item.valid_quantity | commaSeparated }}
										</a>
									</td>
									<td class="al_right">{{ item.valid_amount | toCurrency }}</td>
									<td class="al_right">{{ item.amount | toCurrency }}</td>
									<td class="al_right">{{ item.invoice_amount | toCurrency }}</td>
									<td class="al_right" v-if="user.fob_price_view">{{ item.margin | toCurrency }}</td>
								</tr>
							</template>
						</tbody>
					</template>

					<template v-if="is_summary_display">
						<colgroup>
							<col style="width: 5%;" />
							<col style="width: 10%;" />
							<col style="width: 5%;" />
							<col v-if="company_id == 'beautyplus'" style="width: 5%;" />
							<col style="width: 5%;" />
							<col style="width: 7%;" />
							<col style="width: 5%;" />
							<col />
							<col style="width: 5%;" />
							<col style="width: 7%;" />
							<col style="width: 7%;" />
							<col style="width: 7%;" />
							<col style="width: 7%;" />
							<col v-if="user.fob_price_view" style="width: 5%;" />
							<col style="width: 5%;" />
							<col style="width: 5%;" />
						</colgroup>
						<thead>
							<tr>
								<th>Ship To</th>
								<th>Name</th>
								<th>Sales Group</th>
								<th v-if="company_id == 'beautyplus'">Salesman</th>
								<th>Group</th>
								<th>{{ headers.class }} Code</th>
								<th>Color</th>
								<th>Item Name</th>
								<th>On Hand</th>
								<th>Total Ord Qty.</th>
								<th>Total Ord Amt.</th>
								<th>Total Inv Qty.</th>
								<th>Total Inv Amt.</th>
								<th v-if="user.fob_price_view">FOB Price</th>
								<th>Lock Price</th>
								<th>Price</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in items" v-bind:key="item.invoice_item_no">
								<td class="al_left">
									<a href="javascript:;" @click="gotoPartner(item.ship_to_code)">{{ item.ship_to_code }}</a>
								</td>
								<td class="al_left truncate">
									<a href="javascript:;" @click="gotoPartner(item.ship_to_code)">{{ item.ship_to_name }}</a>
								</td>
								<td class="al_left">{{ item.sales_group_name }}</td>
								<td v-if="company_id == 'beautyplus'" class="al_left">{{ item.salesman_name }}</td>
								<td class="al_left">{{ item.class_group_name }}</td>
								<td class="al_left truncate" :title="item.class_code">{{ item.class_code }}</td>
								<td class="al_center truncate" :title="item.color_code">{{ item.color_code }}</td>
								<td class="al_left truncate" :title="item.item_name">{{ item.item_name && item.item_name.lastIndexOf('-') >= 0 ? item.item_name.substring(0, item.item_name.lastIndexOf('-')) : item.item_name }}</td>
								<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
								<td class="al_right">{{ item.quantity | commaSeparated }}</td>
								<td class="al_right">{{ item.amount | toCurrency }}</td>
								<td class="al_right">{{ item.shipped_quantity | commaSeparated }}</td>
								<td class="al_right">{{ item.invoice_amount | toCurrency }}</td>
								<td class="al_right" v-if="user.fob_price_view">{{ item.fob_price | toCurrency }}</td>
								<td class="al_right">{{ item.lock_price | toCurrency }}</td>
								<td class="al_right">{{ item.real_c_price | toCurrency }}</td>
							</tr>
						</tbody>
					</template>
				</table>
			</div>
		</div>

		<div style="text-align:right;padding-right:10px;">Order Sum : {{ list_sum.quantity | commaSeparated }}, Inv Sum : {{ list_sum.shipped_quantity | commaSeparated }}, Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="view_bottom_bt">
			<a href="javascript:void(0);" type="button" class="search_bt mgr_15" @click="exportExcel">Excel</a>
			<a v-if="user.company_id == 'jc' && by_category_display" href="javascript:void(0);" type="button" class="search_bt mgr_15" @click="excelSBM">SBM Excel</a>
			<span class="int_type" style="width:200px;">
				<input type="text" v-model.trim="user_email" autocomplete="off" @focus="$event.target.select()" />
			</span>
			<a href="javascript:void(0);" type="button" class="search_bt" @click="exportAsyncExcel">Async Excel</a>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'PreemtedSO'" :draggable="false">
			<template slot="title">Preempted SO(s)</template>
			<template slot="body">
				<PreemptedSoPopup :invoice_no="selectedInvoiceNo" :item_id="selectedItemId" v-on:close="closeModal()" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { apiInvoiceIndex } from '@/api/sales/invoice.js';
import { apiSelectSalesGoodsList, apiStreamSalesGoodsList } from '@/api/report/report.js';
import { daysAgo, dateDiff, isDate, today, toDate, yearDiff } from '@/utils/date.js';
import { inputSelectOnClick } from '@/utils/etc.js';
import { exportDataExcel, objectCopy } from '@/api/util';
import { defaultDataType } from 'export-xlsx';

import AC from '@/components/common/AC';
import StateSelect from '@/components/common/StateSelect';
import CountrySelect from '@/components/common/CountrySelect';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import ItemClassSelectMulti from '@/components/common/ItemClassSelectMulti';
import ItemSelectMulti from '@/components/common/ItemSelectMulti';
import ItemClassKeywordSearch from '@/components/common/ItemClassKeywordSearch';
import ItemClassGroup from '@/components/common/ItemClassGroup';

import Modal from '@/components/common/Modal';
import PreemptedSoPopup from '@/components/common/PreemptedSoPopup';

export default {
	props: ['headers'],
	data: function() {
		return {
			is_summary_display: false,
			is_summary: false,
			by_category: false,
			by_category_display: false,

			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			list_sum: {},

			date_type: 'S',
			date_from: daysAgo(14),
			date_to: today(),
			sales_group_code: null,
			keyword: null,

			partner_type: 'S',
			searched_partner: null,
			partners_string: '',
			//ship_tos_string: '',
			//bill_tos_string: '',
			item_classes_string: '',
			colors_string: '',
			selected_items_str: '',
			separator: ',',
			group_code: '',

			option: 'A',

			salesGroups: [],

			items: [],
			modalName: '',
			showModal: false,

			total_amount_sum: 0,

			allSelected: false,

			saveParam: '',
			exportItems: [],
			exportOrderQty: 0,
			exportShipQty: 0,

			sort_key: '',
			sort_direction: 'ASC',

			country: '',
			state: '',

			selectedItemId: null,
			selectdInvoiceNo: null,

			user_email: null,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : null;
		},
		// 사용안하는 듯
		exportData() {
			let data = this.allData;
			for (const item of data) {
				item.status_name = this.$options.filters.saleStatusName(item.status_code);
				item.item_name = item.item_name && item.item_name.lastIndexOf('-') >= 0 ? item.item_name.substring(0, item.item_name.lastIndexOf('-')) : item.item_name;
				item.item_name = item.item_name == null ? item.item_name : item.item_name.replace(/"/g, '\\"');
				item.ship_to_name = item.ship_to_name == null ? item.ship_to_name : item.ship_to_name.replace(/"/g, '\\"');
			}
			return this.allData;
		},
		selected_item_codes() {
			return this.selected_items_str ? this.selected_items_str.split(this.separator) : [];
		},
		partners() {
			return this.partners_string ? this.partners_string.split(this.separator) : [];
		},
		// ship_tos() {
		// 	return this.ship_tos_string ? this.ship_tos_string.split(this.separator) : [];
		// },
		item_classes() {
			// return this.item_classes_string ? this.item_classes_string.split(this.separator) : [];
			return this.item_classes_string ? this.item_classes_string.split(/ |,/) : [];
		},
		colors() {
			return this.colors_string ? this.colors_string.split(this.separator) : [];
		},
		// jc By Category: sort by class group and insert subtotal rows
		display_items() {
			if (!this.by_category_display) return this.items;

			const groups = {};
			const group_keys = [];
			this.items.forEach(item => {
				const key = item.class_group_name || 'N/A';
				if (!groups[key]) {
					groups[key] = [];
					group_keys.push(key);
				}
				groups[key].push(item);
			});
			group_keys.sort();

			const rows = [];
			group_keys.forEach(key => {
				const group_items = groups[key];
				const subtotal = { is_subtotal: true, subtotal_key: key, class_group_name: key, line_count: group_items.length, quantity: 0, shipped_quantity: 0, discount_amount: 0, amount: 0, invoice_amount: 0 };
				group_items.forEach(it => {
					subtotal.quantity += Number(it.quantity || 0);
					subtotal.shipped_quantity += Number(it.shipped_quantity || 0);
					subtotal.discount_amount += this.jcDiscount(it);
					subtotal.amount += Number(it.amount || 0);
					subtotal.invoice_amount += Number(it.invoice_amount || 0);
				});
				rows.push(...group_items);
				rows.push(subtotal);
			});
			return rows;
		},
	},
	components: {
		CountrySelect,
		StateSelect,
		CustomDatePicker,
		Paging,
		CodeSelect,
		PartnerSelect,
		ItemClassSelectMulti,
		ItemSelectMulti,
		ItemClassKeywordSearch,
		ItemClassGroup,
		AC,
		Modal,
		PreemptedSoPopup,
	},
	methods: {
		addSearchingItemClasses(itemClassList) {
			//console.log(itemClassList);
			if (!itemClassList || !itemClassList.length) return;
			this.item_classes_string = itemClassList.map(cls => cls.code).join(this.separator);

			// this.selectData();
		},
		selectPreemptedList(invoice_no, item_id) {
			if (this.user.preempted_so_view) {
				this.selectedItemId = item_id;
				this.selectedInvoiceNo = invoice_no;
				this.modalName = 'PreemtedSO';
				this.showModal = true;
			}
		},
		closeModal() {
			this.showModal = false;
		},
		// jc: per-line discount = (lock price - unit price) x invoiced qty
		jcDiscount(item) {
			if (!item || item.is_subtotal) return 0;
			const diff = Number(item.lock_price || 0) - Number(item.unit_price || 0);
			if (diff <= 0) return 0;
			const qty = Number(item.shipped_quantity || 0);
			return Math.round(diff * qty * 100) / 100;
		},
		selectColor(item) {
			let routeData = this.$router.resolve({ name: 'salesGoods', query: { backUri: this.uri, class_code: item.class_code, color_code: item.color_code } });
			window.open(routeData.href, 'herp_sales_goods');
		},
		sortMark: function(sort_key) {
			if (this.sort_key === sort_key) return this.sort_direction === 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key === sort_key) {
				this.sort_direction = this.sort_direction === 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.search();
		},
		selectClasses(input) {
			return process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&include_closed_yn=Y&keyword=' + input;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			if (this.item_classes_string) this.item_classes_string += this.separator + c.selectedObject.code;
			else this.item_classes_string = c.selectedObject.code;
		},
		setPartner(partner) {
			if (this.partners_string) this.partners_string += this.separator + partner.code;
			else this.partners_string = partner.code;
		},
		selectAll() {
			var vm = this;
			this.items.forEach(function(item) {
				item.selected = vm.allSelected;
			});
		},
		selectInvoice(item) {
			let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: item.invoice_no } });
			window.open(routeData.href, '_blank');
		},
		selectSO(item) {
			let routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: item.invoice_no } });
			window.open(routeData.href, '_blank');
		},
		async exportAsyncExcel() {
			if (!this.user_email) {
				this.$toast.error('Email is empty');
				return false;
			}

			if (!this.checkAsyncSearchCondition()) return;

			const ok = window.confirm("This request will be processed in tonight's batch (around 2:00 AM) and the result will be emailed to " + this.user_email + '.\n\nUp to 5 pending requests per company are allowed.\n\nProceed?');
			if (!ok) return;

			this.makeSaveParam();
			let asyncParam = objectCopy(this.saveParam);
			asyncParam.user_email = this.user_email;

			try {
				const result = await apiStreamSalesGoodsList(asyncParam);
				if (result.status == 202) {
					this.$toast.success(result.data.message);
				} else {
					this.$toast.error(result.data && result.data.message ? result.data.message : result.statusText);
				}
			} catch (err) {
				const msg = err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Failed to queue the report request';
				this.$toast.error(msg);
			}
		},
		async exportExcel() {
			if (!this.saveParam) {
				this.$toast.error('Please search first');
				return false;
			}

			if (!this.checkSearchCondition()) return;

			if (this.list_count > 50000) {
				this.$toast.error('Use "Async Excel" for 50,000+ cases. Available via email (up to 5 years).');
				return;
			}

			const { data } = await apiSelectSalesGoodsList(this.saveParam);
			for (const item of data.salesGoodsList) {
				item.status_name = this.$options.filters.saleStatusName(item.status_code);
				item.item_name = item.item_name && item.item_name.lastIndexOf('-') >= 0 ? item.item_name.substring(0, item.item_name.lastIndexOf('-')) : item.item_name;
			}

			// --------------stimulsoft export code----------------
			// const reportTemplate = await apiGetReportTemplate('salesGood', reportMrtUrl('salesGood'));
			// const report = new Report(reportTemplate, data, 'salesGood');
			// exportFile(report, 'excel');

			// --------------java export code----------------
			// await apiPostFileDownload('/api/report/selectSalesGoodsList/excel', this.saveParam, 'salesGoods.xlsx');

			let header = null;
			if (this.is_summary_display) {
				header = [
					{ key: 'ship_to_code', name: 'Ship To', width: 15 },
					{ key: 'ship_to_name', name: 'Name', width: 15 },
					{ key: 'sales_group_name', name: 'Sales Group', width: 15 },
					{ key: 'class_group_name', name: 'Group', width: 15 },
					{ key: 'class_code', name: `${this.headers.class} Code`, width: 15 },
					{ key: 'color_code', name: 'Color', width: 15 },
					{ key: 'item_name', name: 'Item Name', width: 15 },
					{ key: 'on_hand', name: 'on Hand', width: 15, dataType: defaultDataType.currency },
					{ key: 'quantity', name: 'Total Ord Qty.', width: 15, dataType: defaultDataType.currency },
					{ key: 'amount', name: 'Total Ord Amt.', width: 15, dataType: defaultDataType.number },
					{ key: 'shipped_quantity', name: 'Total Inv Qty.', width: 15, dataType: defaultDataType.currency },
					{ key: 'invoice_amount', name: 'Total Inv Amt.', width: 15, dataType: defaultDataType.number },
					{ key: 'lock_price', name: 'Lock Price', width: 15, dataType: defaultDataType.number },
					{ key: 'real_c_price', name: 'Price', width: 15, dataType: defaultDataType.number },
				];

				if (this.user.fob_price_view) header.splice(12, 0, { key: 'fob_price', name: 'FOB Price', width: 15, dataType: defaultDataType.number });
				if (this.company_id == 'beautyplus') {
					const sg_idx = header.findIndex(h => h.key === 'sales_group_name');
					if (sg_idx > -1) header.splice(sg_idx + 1, 0, { key: 'salesman_name', name: 'Salesman', width: 15 });
				}
			} else {
				header = [
					{ key: 'so_dn', name: 'So No', width: 15 },
					{ key: 'so_date', name: 'So Date', width: 15 },
					{ key: 'status_name', name: 'Status', width: 15 },
					{ key: 'invoice_dn', name: 'Inv. No', width: 15 },
					{ key: 'invoice_date', name: 'Inv. Date', width: 15 },
					{ key: 'approval_dt', name: 'Approval Time', width: 15 },
					{ key: 'invoice_type', name: 'Type', width: 15 },
					{ key: 'ship_to_code', name: 'Ship To', width: 15 },
					{ key: 'ship_to_name', name: 'Name', width: 15 },
					{ key: 'territory_code', name: 'Terr', width: 5 },
					{ key: 'sales_group_name', name: 'Sales Group', width: 15 },
					{ key: 'class_group_name', name: 'Group', width: 15 },
					{ key: 'class_code', name: `${this.headers.class} Code`, width: 15 },
					{ key: 'color_code', name: 'Color', width: 15 },
					{ key: 'item_name', name: 'Item', width: 15 },
					{ key: 'on_hand', name: 'on Hand', width: 15, dataType: defaultDataType.currency },
					{ key: 'quantity', name: 'Order Qty.', width: 15, dataType: defaultDataType.currency },
					{ key: 'shipped_quantity', name: 'Inv Qty.', width: 15, dataType: defaultDataType.currency },
					{ key: 'box_count', name: 'Box', width: 10, dataType: defaultDataType.currency },
					{ key: 'lock_price', name: 'Lock Price', width: 15, dataType: defaultDataType.number },
					{ key: 'unit_price', name: 'Price', width: 15, dataType: defaultDataType.number },
					{ key: 'valid_quantity', name: 'Available Qty', width: 15, dataType: defaultDataType.currency },
					{ key: 'valid_amount', name: 'Available Amount', width: 15, dataType: defaultDataType.number },
					{ key: 'amount', name: 'Amount', width: 15, dataType: defaultDataType.number },
					{ key: 'invoice_amount', name: 'Invoice Amount', width: 15, dataType: defaultDataType.number },
					{ key: 'remark', name: 'Remark', width: 15 },
				];

				if (this.user.fob_price_view) {
					header.splice(17, 0, { key: 'fob_price', name: 'FOB Price', width: 15, dataType: defaultDataType.number });
					header.splice(26, 0, { key: 'margin', name: 'Margin', width: 15, dataType: defaultDataType.number });
				}

				if (this.company_id == 'beautyplus') {
					header.splice(10, 0, { key: 'address_state', name: 'State', width: 6, dataType: defaultDataType.number });
					const sg_idx = header.findIndex(h => h.key === 'sales_group_name');
					if (sg_idx > -1) header.splice(sg_idx + 1, 0, { key: 'salesman_name', name: 'Salesman', width: 15 });
				}

				if (this.company_id == 'jc') {
					for (const item of data.salesGoodsList) item.discount_amount = this.jcDiscount(item);
					const price_idx = header.findIndex(h => h.key === 'unit_price');
					if (price_idx > -1) header.splice(price_idx + 1, 0, { key: 'discount_amount', name: 'Discount', width: 15, dataType: defaultDataType.number });
				}
			}

			exportDataExcel(data.salesGoodsList, header, 'SalesGoods');
		},
		excelSBM() {
			if (!this.by_category_display) {
				this.$toast.error('Run By Category search first.');
				return;
			}
			const desc = name => (this.company_id !== 'newjigu' && name && name.lastIndexOf('-') >= 0 ? name.substring(0, name.lastIndexOf('-')) : name);
			const rows = [];
			let all_qty = 0;
			let all_disc = 0;
			let all_total = 0;
			this.items.forEach(it => {
				all_qty += Number(it.shipped_quantity || 0);
				all_disc += this.jcDiscount(it);
				all_total += Number(it.invoice_amount || 0);
			});
			rows.push({ category: 'ALL (' + this.items.length + ')', shipped_quantity: all_qty, discount: all_disc, invoice_amount: all_total });
			this.display_items.forEach(it => {
				if (it.is_subtotal) {
					rows.push({ category: it.class_group_name + ' (' + it.line_count + ')', shipped_quantity: it.shipped_quantity, discount: it.discount_amount, invoice_amount: it.invoice_amount });
				} else {
					rows.push({
						category: it.class_group_name,
						invoice_date: it.invoice_date,
						invoice_dn: it.invoice_dn,
						item_code: it.item_code,
						item_name: desc(it.item_name),
						shipped_quantity: it.shipped_quantity,
						unit_price: it.unit_price,
						discount: this.jcDiscount(it),
						invoice_amount: it.invoice_amount,
					});
				}
			});
			const header = [
				{ key: 'category', name: 'Category 1', width: 18 },
				{ key: 'invoice_date', name: 'Trans Date', width: 14 },
				{ key: 'invoice_dn', name: 'Trans #', width: 15 },
				{ key: 'item_code', name: 'Item #', width: 16 },
				{ key: 'item_name', name: 'Description', width: 45 },
				{ key: 'shipped_quantity', name: 'Qty', width: 10, dataType: defaultDataType.currency },
				{ key: 'unit_price', name: 'Unit Price', width: 12, dataType: defaultDataType.number },
				{ key: 'discount', name: 'Discount', width: 12, dataType: defaultDataType.number },
				{ key: 'invoice_amount', name: 'Line Total', width: 14, dataType: defaultDataType.number },
			];
			exportDataExcel(rows, header, 'DailySoldDetailByCategorySBM');
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectSalesGoodsList(pageNo);
		},
		reset() {
			this.date_type = 'S';
			this.date_from = daysAgo(14);
			this.date_to = today();
			this.option = 'A';
			this.sales_group_code = null;
			this.item_classes_string = '';
			this.colors_string = '';
			this.partner_type = 'S';
			this.partners_string = '';
			this.selected_items_str = '';
			this.group_code = '';
		},
		checkSearchCondition() {
			if (!this.date_from || !isDate(this.date_from) || !this.date_to || !isDate(this.date_to)) {
				this.$toast.error('Invalid date');
				return false;
			}

			var date_from = toDate(this.date_from);
			var date_to = toDate(this.date_to);

			const yearDifference = yearDiff(date_from, date_to);

			// if (this.company_id === 'newjigu') {
			// 	if (this.partners.length == 0 && this.selected_item_codes.length == 0 && this.item_classes.length == 0 && dateDiff(date_from, date_to) > 60) {
			// 		this.$toast.error('Maximum search period without item and partner condition is 60 days');
			// 		return false;
			// 	}
			// } else {
			// 	if (this.selected_item_codes.length == 0 && this.item_classes.length == 0 && dateDiff(date_from, date_to) > 60) {
			// 		this.$toast.error('Maximum search period without item condition is 60 days');
			// 		return false;
			// 	}
			// }

			let max_years = 1;
			if (this.user.company_id == 'jc') max_years = 3;

			if (this.selected_item_codes.length == 0 && this.item_classes.length == 0 && yearDifference >= max_years) {
				this.$toast.error('Search period exceeds ' + max_years + ' year(s). Please use "Async Excel" (up to 5 years).');
				return false;
			}

			return true;
		},
		checkAsyncSearchCondition() {
			if (!this.date_from || !isDate(this.date_from) || !this.date_to || !isDate(this.date_to)) {
				this.$toast.error('Invalid date');
				return false;
			}

			var date_from = toDate(this.date_from);
			var date_to = toDate(this.date_to);

			if (dateDiff(date_from, date_to) > 365 * 5) {
				this.$toast.error('Maximum search period is 5 years.');
				return false;
			}

			return true;
		},
		search() {
			if (!this.checkSearchCondition()) return;

			this.selectSalesGoodsList();
		},
		makeSaveParam() {
			let saveParam = {
				is_summary: this.is_summary,

				option: this.option,
				sales_group_code: this.sales_group_code,
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,

				color_codes: this.colors,
				item_classes: this.item_classes,
				item_codes: this.selected_item_codes,
				group_code: this.group_code,
				//ship_tos: this.ship_tos,
				country: this.country,
				state: this.state,
			};
			if (this.date_type === 'S') {
				saveParam.so_date_from = this.date_from;
				saveParam.so_date_to = this.date_to;
			} else if (this.date_type === 'I') {
				saveParam.invoice_date_from = this.date_from;
				saveParam.invoice_date_to = this.date_to;
			}

			if (this.partner_type === 'S') {
				saveParam.ship_tos = this.partners;
			} else if (this.partner_type === 'B') {
				saveParam.bill_tos = this.partners;
			}

			if (this.user.fob_price_view) saveParam.include_fob_price = true;

			this.saveParam = objectCopy(saveParam);
		},
		async selectSalesGoodsList(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			this.is_summary_display = this.is_summary;
			this.by_category_display = this.user.company_id == 'jc' && !this.is_summary && this.by_category;

			this.makeSaveParam();

			if (this.by_category_display) {
				// guard the unpaged query: check the row count first
				const { data: count_data } = await apiSelectSalesGoodsList({ ...this.saveParam, paging_yn: 'Y', page_size: 1, page_no: 1, start_index: 0 });
				if (count_data.salesGoodsSum.list_count > 10000) {
					this.$toast.error('By Category supports up to 10,000 rows (' + count_data.salesGoodsSum.list_count + ' rows found). Please narrow the search or use Async Excel.');
					return;
				}
			}

			let param = {
				...this.saveParam,
				paging_yn: this.by_category_display ? 'N' : this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
			};

			const { data } = await apiSelectSalesGoodsList(param);

			this.items = data.salesGoodsList;
			this.list_count = data.salesGoodsSum.list_count;
			this.list_sum.quantity = data.salesGoodsSum.quantity;
			this.list_sum.shipped_quantity = data.salesGoodsSum.shipped_quantity;

			if (this.by_category_display) this.$refs.paging.setPage(1, Math.max(this.list_count, 1), this.list_count);
			else this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);
		},
		gotoPartner(code) {
			//this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, code: code } });
			let routeData = this.$router.resolve({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, code: code } });
			window.open(routeData.href, 'herp_partner');
		},
		setDefaultSort() {
			if (this.company_id === 'newjigu') {
				this.sort_key = 'invoice_date';
				this.sort_direction = 'DESC';
			}
		},
		async index() {
			const { data } = await apiInvoiceIndex();

			this.salesGroups = data.salesGroupList;
		},
		async init() {
			await this.index();
			this.setDefaultSort();

			if (this.company_id === 'newjigu') this.country = '';

			if (this.$route.query.invoice_type) this.invoice_type = this.$route.query.invoice_type;
			if (this.$route.query.option) this.invoice_type = this.$route.query.option;
			if (this.$route.query.date_type) this.date_type = this.$route.query.date_type;
			if (this.$route.query.date_from) {
				if (this.$route.query.date_from === 'NON_SELECT') this.date_from = daysAgo(60);
				else this.date_from = this.$route.query.date_from;
			}
			if (this.$route.query.date_to) {
				if (this.$route.query.date_to === 'NON_SELECT') this.date_to = today();
				else this.date_to = this.$route.query.date_to;
			}
			if (this.$route.query.sales_group_code) this.sales_group_code = this.$route.query.sales_group_code;

			if (this.$route.query.ship_tos_string) {
				this.partners_string = this.$route.query.ship_tos_string;
				this.$nextTick(() => {
					this.search();
				});
			} else if (this.$route.query.class_code && this.$route.query.color_code) {
				this.item_classes_string = this.$route.query.class_code;
				this.colors_string = this.$route.query.color_code;
				this.$nextTick(() => {
					this.search();
				});
			}

			this.user_email = this.user.email;
			if (this.user_email == '' || this.user_email == null) this.$toast.info('The default email address for "Async Excel" can be configured under User Settings.');
		},
	},
	mounted() {
		inputSelectOnClick();
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_sales_goods');
		this.$store.commit('setSubTitle', 'Report -> Sales Goods');

		this.init();
	},
};
</script>

<style></style>
